<template>
  <div class="nuttrema-registration-carousel">

    <el-carousel trigger="click" height="100vh" :autoplay="true" :interval="30000" indicator-position="none">

      <el-carousel-item>
        <div class="nuttrema-registration-carousel__item">

          <div class="item_text">
            <h1 v-html="_markdown.renderInline($t('label.registration_nutritionists_title'))"></h1>
            <h4 v-html="_markdown.renderInline($t('label.registration_nutritionists_paragraph_one'))"></h4>
            <h4 v-html="_markdown.renderInline($t('label.registration_nutritionists_paragraph_two'))"></h4>
          </div>

          <div class="item_bg" :style="getStyle('nutritionists', 1)"></div>
        </div>
      </el-carousel-item>

      <el-carousel-item>
        <div class="nuttrema-registration-carousel__item">

          <div class="item_text">
            <h1 v-html="_markdown.renderInline($t('label.registration_food_producers_title'))"></h1>
            <h4 v-html="_markdown.renderInline($t('label.registration_food_producers_paragraph_one'))"></h4>
            <h4 v-html="_markdown.renderInline($t('label.registration_food_producers_paragraph_two'))"></h4>
          </div>

          <div class="item_bg" :style="getStyle('food-producers', 4)"></div>
        </div>
      </el-carousel-item>

      <el-carousel-item>
        <div class="nuttrema-registration-carousel__item">

          <div class="item_text">
            <h1 v-html="_markdown.renderInline($t('label.registration_chefs_title'))"></h1>
            <h4 v-html="_markdown.renderInline($t('label.registration_chefs_paragraph_one'))"></h4>
            <h4 v-html="_markdown.renderInline($t('label.registration_chefs_paragraph_two'))"></h4>
          </div>

          <div class="item_bg" :style="getStyle('chefs', 2)"></div>
        </div>
      </el-carousel-item>

      <el-carousel-item>
        <div class="nuttrema-registration-carousel__item">

          <div class="item_text">
            <h1 v-html="_markdown.renderInline($t('label.registration_foodies_title'))"></h1>
            <h4 v-html="_markdown.renderInline($t('label.registration_foodies_paragraph_one'))"></h4>
            <h4 v-html="_markdown.renderInline($t('label.registration_foodies_paragraph_two'))"></h4>
            <h5 v-html="_markdown.renderInline($t('label.registration_foodies_note'))"></h5>
          </div>

          <div class="item_bg" :style="getStyle('foodies', 2)"></div>
        </div>
      </el-carousel-item>

      <el-carousel-item>
        <div class="nuttrema-registration-carousel__item">

          <div class="item_text">
            <h1 v-html="_markdown.renderInline($t('label.registration_education_title'))"></h1>
            <h4 v-html="_markdown.renderInline($t('label.registration_education_paragraph_one'))"></h4>
            <h4 v-html="_markdown.renderInline($t('label.registration_education_paragraph_two'))"></h4>
          </div>

          <div class="item_bg" :style="getStyle('education', 1)"></div>
        </div>
      </el-carousel-item>

    </el-carousel>

    <div class="nuttrema-registration-carousel__logo">
      <a href="http://www.diet-creator.com" target="_blank">
        <img src="~assets/images/dc-logo-small-white.svg"/>
      </a>
    </div>

    <div class="nuttrema-registration-carousel__powered_by">
      <img src="~assets/images/dc-logo-powered-by-white.png"/>
    </div>
  </div>
</template>

<script>
import { random, get } from 'lodash';

export default {
  name: 'nuttrema-registration-carousel',
  data() {
    return {
    };
  },
  methods: {
    getStyle(type, numbers) {
      const baseURL = get(window, 'location.origin');
      let item = random(1, numbers);
      item = item < 10 ? `0${item}` : item;
      return { 'background-image': `url(${baseURL}/static/registration/${type}-slide-${item}.jpg)` };
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '~styles/mixins/gradients';

  .nuttrema-registration-carousel {
    display: flex;
    position: absolute;
    flex-direction: column;
    justify-content: space-between;
    top: 0; left: 0; bottom: 0; right: 0;

    .el-carousel {
      z-index: 0;
      position: absolute;
      top: 0; left: 0; bottom: 0; right: 0;
    }

    .nuttrema-registration-carousel__item {
      flex-grow: 1;
      display: flex;
      height: 100vh;
      align-self: stretch;
      flex-direction: column;
      justify-content: flex-end;


      h1, h4, h5{
        color: #fff;
        text-align: center;
        font-family: 'Asap';
      }

      h1 {
        font-size: 2.75rem;
        line-height: 2.75rem;
        font-weight: 700;
        margin-bottom: 0.5em;
      }

      h4 {
        font-size: 1.1rem;
        line-height: 1.5rem;
        font-weight: 600;
        margin-bottom: 0.5em;
      }

      .item_text {
        z-index: 1;
        padding: 5em 1em 5em 1em;
        @include gradient-vertical(rgba(0,0,0, 0), rgba(0,0,0, 0.85));
      }

      .item_bg {
        z-index: 0;
        position: absolute;
        background-size: auto 100%;
        background-position: center;
        background-repeat: no-repeat;
        top: 0; left: 0; bottom: 0; right: 0;
      }
    }

    .nuttrema-registration-carousel__logo {
      z-index: 1;
      display: flex;
      padding: 1em 0;
      align-items: center;
      justify-content: center;
      > a {
        width: 25%;
        i {
          width: 100%;
        }
      }
    }

    .nuttrema-registration-carousel__powered_by {
      z-index: 1;
      display: flex;
      padding: 1em;
      align-items: center;
      justify-content: flex-end;
      > img {
        width: 55%;
      }
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/ui/carousel/nuttrema-registration-carousel.vue